import React, { Fragment, useState } from 'react';
import List from "@mui/material/List";
import ListItem from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import { NavLink } from "react-router-dom";
import './style.css';

const menus = [
    {
        id: 1,
        title: 'Home',
        link: '/',
    },
    {
        id: 2,
        title: 'About',
        link: '/about',
    },
        {
        id: 2.5,
        title: 'Missions',
        link: '/mission',
    },
    {
        id: 3,
        title: 'Our Impact',
        link: '/impact',
    },
   
    {
        id: 5,
        title: 'News',
        link: '/news',

    },
     {
        id: 6,
        title: 'Donate',
        link: '/donate',

    },
   
    {
        id: 7,
        title: 'Contact',
        link: '/contact',
    }


]


const MobileMenu_v2 = () => {

    const [openId, setOpenId] = useState(0);
    const [menuActive, setMenuState] = useState(false);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <div>
            <div className={`mobileMenu ${menuActive ? "show" : ""}`}>
                <div className="menu-close">
                    <div className="clox" onClick={() => setMenuState(!menuActive)}><i className="ti-close"></i></div>
                </div>

                <ul className="responsivemenu">
                    {menus.map((item, mn) => {
    const isExternal = item.link.startsWith('http');

    return (
        <ListItem className={item.id === openId ? 'active' : null} key={mn}>
            {item.submenu ? (
                <Fragment>
                    <p onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>
                        {item.title}
                        <i className={item.id === openId ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                    </p>
                    <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                        <List className="subMenu">
                            {item.submenu.map((submenu, i) => (
                                <ListItem key={i}>
                                    <NavLink onClick={ClickHandler} className="active" to={submenu.link}>
                                        {submenu.title}
                                    </NavLink>
                                </ListItem>
                            ))}
                        </List>
                    </Collapse>
                </Fragment>
            ) : isExternal ? (
                <a
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={ClickHandler}
                    className="active"
                >
                    {item.title}
                </a>
            ) : (
                <NavLink onClick={ClickHandler} className="active" to={item.link}>
                    {item.title}
                </NavLink>
            )}
        </ListItem>
    );
})}

                </ul>

            </div>

            <div className="showmenu mobail-menu" onClick={() => setMenuState(!menuActive)}>
                <button type="button" className="navbar-toggler open-btn">
                    <span className="icon-bar first-angle"></span>
                    <span className="icon-bar middle-angle"></span>
                    <span className="icon-bar last-angle"></span>
                </button>
            </div>
        </div>
    )
}

export default MobileMenu_v2;